import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { Box, Card, Spinner, Typography, WithInfoIcon } from 'seagull';
import { CloseCross } from 'seagull/icons/essentials/CloseCross';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './MetricsCard.module.scss';
export const GetMetricsCardTID = (parentTestId)=>getTestIds(parentTestId);
export const MetricsCard = (param)=>{
    let { title, tooltip, isActive = false, isDisabled = false, isEditMode = false, isLoading = false, isRefetching = false, onRemove, dragHandle, onClick, children, testId } = param;
    const { MetricsCardTestIds } = useMemo(()=>GetMetricsCardTID(testId), [
        testId
    ]);
    const { t: invoiceMetricsSectionTexts } = useLocaleKeys('components.invoiceMetricsSection');
    const isClickable = !isEditMode && onClick != null && !isDisabled;
    const handleClick = ()=>{
        if (isClickable) onClick();
    };
    const titleNode = /*#__PURE__*/ _jsx(Typography, {
        variant: "paragraph3",
        skin: "secondary",
        className: cn(styles.title, {
            [styles.titleDisabled]: isDisabled
        }),
        testId: MetricsCardTestIds.Title(),
        children: title
    });
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.cardWrapper,
        children: [
            /*#__PURE__*/ _jsxs(Card, {
                bi: {
                    name: 'invoice_metrics_card'
                },
                testId: MetricsCardTestIds.Root(),
                padding: "m",
                highlightOnHover: isClickable,
                as: isClickable ? 'button' : 'div',
                className: cn(styles.card, {
                    [styles.active]: isActive,
                    [styles.disabled]: isDisabled,
                    [styles.clickable]: isClickable,
                    [styles.editMode]: isEditMode,
                    [styles.refetching]: isRefetching && !isLoading
                }),
                disableSeparator: true,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.header,
                        children: /*#__PURE__*/ _jsxs(Box, {
                            className: styles.titleRow,
                            children: [
                                isEditMode && dragHandle,
                                tooltip != null ? /*#__PURE__*/ _jsx(WithInfoIcon, {
                                    info: tooltip,
                                    infoTestId: MetricsCardTestIds.InfoIcon(),
                                    children: titleNode
                                }) : titleNode
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.body,
                        children: isLoading ? /*#__PURE__*/ _jsx(Box, {
                            className: styles.loader,
                            children: /*#__PURE__*/ _jsx(Spinner, {
                                intent: "primary",
                                size: 28,
                                testId: MetricsCardTestIds.Spinner()
                            })
                        }) : children
                    })
                ]
            }),
            isEditMode && onRemove != null && /*#__PURE__*/ _jsx("button", {
                type: "button",
                "data-testid": MetricsCardTestIds.RemoveButton(),
                className: styles.removeBadge,
                onClick: (e)=>{
                    e.stopPropagation();
                    onRemove();
                },
                "aria-label": invoiceMetricsSectionTexts.removeCardAriaLabel(),
                children: /*#__PURE__*/ _jsx(CloseCross, {
                    size: 12
                })
            })
        ]
    });
};
